import { useFeatureGate } from "@statsig/react-bindings";

import { featureFlag, FeatureName } from "@/context/FeatureFlagProvider/featureFlags";

export type FeatureFlaggedProps = {
  featureName: FeatureName;
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export function FeatureFlagged({ featureName, children, fallback = null }: FeatureFlaggedProps) {
  const featureKey = featureFlag[featureName];
  const { value } = useFeatureGate(featureKey);

  if (value) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
}
